import { StyleSheet } from 'aphrodite';
import { CssSelectors, FontFamilies } from '../../../../web/styles/styles';
import { backgroundGreen, brandPrimary } from '../../../styles/colors';
import { aidaBaseStyles } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	companyLink: {
		textDecoration: 'none',
		justifyContent: 'flex-start',
		textAlign: 'start',
		fontSize: 16,
		':hover': {
			textDecoration: 'none',
		},
	},
	dot: {
		borderRadius: '50%',
		height: 10,
		marginLeft: 5,
		width: 10,
	},
	iconPosition: {
		marginBottom: -1,
		marginLeft: 6,
	},
	label: {
		display: 'inline-block',
		fontSize: '11px',
		minWidth: 90,
		textAlign: 'right',
		textTransform: 'uppercase',
	},
	lastDealContainer: {
		background: backgroundGreen,
		borderRadius: 14,
		color: brandPrimary,
		display: 'inline-block',
		height: '50',
		padding: '10px 14px',
		width: '100',
		...CssSelectors.allDescendants({
			color: brandPrimary,
			fontFamily: FontFamilies.semiBold,
		}),
	},
	lastInteraction: {
		...aidaBaseStyles.flexHorizontalCenter,
		':first-child': {
			marginBottom: 4,
		},
		...CssSelectors.allChildren(
			{
				fontSize: '12px',
				paddingLeft: 5,
			},
			'span:last-child'
		),
	},
	recordingLink: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontFamily: FontFamilies.semiBold,
		fontSize: 'inherit',
		padding: 0,
		textDecoration: 'underline',
		':hover': {
			opacity: 0.8,
		},
	},
});
